import React, {useState,  useEffect, useRef} from 'react';
import ReviewCard from './ReviewCard';

const ReviewCarousel = ({ reviews }) => {
  const maxItems = 6;
  const items = reviews.slice(0, maxItems);

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 900;
  const groupedItems = [];

  for (let i = 0; i < items.length; i += isMobile ? 1 : 2) {
    groupedItems.push(items.slice(i, i + (isMobile ? 1 : 2)));
  }

  const total = groupedItems.length;

  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setCurrent(0);
    };

    window.addEventListener('resize', handleResize);
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 3000);

    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener('resize', handleResize);
    };
  }, [current, total]);

  return (
    <div className="relative overflow-hidden">
      <div
        className="flex mb-8"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {groupedItems.map((group, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 w-full flex justify-center space-x-4 px-4"
          >
            {group.map((review, i) => (
              <div
                key={i}
                className="w-full md:w-1/2"
              >
                <ReviewCard {...review} />
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Dots Indicator */}
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2 mt-2">
        {groupedItems.map((_, idx) => (
          <button
            key={idx}
            className={`w-3 h-3 rounded-full focus:outline-none ${
              idx === current ? 'bg-gray-800' : 'bg-gray-400'
            }`}
            onClick={() => setCurrent(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default ReviewCarousel;